import React from "react";
import ReactHtmlParser from "react-html-parser";
import dayjs from "dayjs";
import { content } from "../../utils/content/product";
// import verifiedCustomer from "../../public/images/products/verified.svg";

const ReviewCard = ({ review, lang }) => {
  return (
    <div className="mb-4">
      <div className="bg-white flex flex-col space-y-4 sm:p-6 p-3 custom-box-shadow">
        <div className="flex space-x-4 align-items-start mb-3 text-base">
          <div className="">
            <span className="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-green-500 text-white box-content h-6">
              {review.rating ? review.rating : null}
              <button
                type="button"
                className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-white hover:bg-green-400 hover:text-indigo-500 focus:outline-none focus:bg-indigo-500 focus:text-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 text-white w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              </button>
            </span>
          </div>
          {review.title ? (
            <p className="font-bold text-black text-xl">{review.title}</p>
          ) : null}
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: ReactHtmlParser(review.review),
          }}
        ></div>
        <div className="text-gray-400">
          <div className="flex space-x-4">
            <p className="font-bold mb-0 text-gray-500 text-base">
              {review.user_name && review.user_name}
            </p>
            {review.verified === 1 && (
              <div className="flex">
                <img
                  src="/images/products/verified.svg"
                  width="25"
                  height="25"
                  className="mr-2 review-verified"
                />
                <p className="font-regular mb-0 text-gray-400 text-base">
                  {content["verifiedCustomers"][lang]}
                </p>
              </div>
            )}
          </div>
          <p className="font-regular mb-0 text-gray-400 text-base">
            {review.created_on
              ? dayjs(review.created_on).format("MMMM DD, YYYY")
              : null}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
